import React, { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getOrgMemberOwnerExistsValue } from "../../../../../Actions/API/AuthenticationActions"
import { acceptInvitationToOrg } from "../../../../../Actions/API/Org/OrgMemberActions"
import { useAppState } from "../../../../../Hooks/useReduxState"
import { routePaths } from "../../../../../Routes"
import { InvitationAccept } from "../../Common/InvitationAccept"

interface MemberSignUpProps {
    orgUsername: string
    memberId: number
    code: string
}

export function MemberSignUp({
    orgUsername,
    memberId,
    code
}: MemberSignUpProps) {
    const dispatch = useDispatch()
    const email = useAppState(
        state => state.api.authentication.orgMemberOwnerExists[memberId]?.email
    )
    const invitation = useMemo(
        () => ({
            type: "organization-member" as const,
            orgUsername,
            memberId,
            code
        }),
        [code, memberId, orgUsername]
    )

    useEffect(() => {
        if (email === undefined) {
            dispatch(getOrgMemberOwnerExistsValue(orgUsername, memberId, code))
        }
    }, [code, dispatch, email, memberId, orgUsername])

    return (
        <InvitationAccept
            invitation={invitation}
            email={email}
            acceptAction={acceptInvitationToOrg(orgUsername, memberId, code)}
            redirectRouteOnComplete={routePaths.orgHome(orgUsername)}
        />
    )
}
